function helperDefaultCompare (v1, v2) {
  return v1 === v2
}

module.exports = helperDefaultCompare



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/base/helperDefaultCompare.js
// module id = 585
// module chunks = 106